import { atom, getDefaultStore, useAtom } from 'jotai';
import {
  type flags,
  supportedLanguages
} from '../../../Common/ChainManager/Insert/Translate/countriesData';
import i18n from 'i18next';
import { useLocation } from 'react-router-dom';

// This will not cause a rerender.

const langParam = new URLSearchParams(location.search).get('lang')?.toUpperCase();

const languageMatch = /([^-]*-?(.*))/.exec(navigator.language);

const baseLang = (languageMatch?.[2] || languageMatch?.[1] || 'IT').toUpperCase();

export const DEFAULT_BROWSER_LANGUAGE = supportedLanguages.has(baseLang) ? baseLang : 'US';

const forceLang = langParam && supportedLanguages.has(langParam) ? langParam : undefined;

if (forceLang) {
  localStorage.setItem('lang', forceLang);
}

const isDataPage = () => {
  const location = useLocation();
  return [
    '/page',
    '/trace-view',
    '/settings/company',
    '/settings/product',
    '/company',
    '/products/',
    '/lot'
  ].some((it) => location.pathname.startsWith(it));
};

export const selectedLanguageAtom = atom(
  localStorage.getItem('lang')?.toUpperCase() ?? DEFAULT_BROWSER_LANGUAGE
);

export const setLocale = (locale: string) => {
  localStorage.setItem('lang', locale);
  i18n
    .loadNamespaces(locale)
    .then(() => i18n.changeLanguage(locale))
    .then(() => getDefaultStore().set(selectedLanguageAtom, locale));
  // This will update every page which use useSelectedLanguage!
};

export const availableLanguagesAtom = atom<(keyof typeof flags)[]>(['IT', 'US']);

export const useSelectedLanguage = () => {
  const selected = useAtom(selectedLanguageAtom, { store: getDefaultStore() })[0];
  const defaultLang = selected === 'IT' ? 'IT' : 'US';
  if (isDataPage()) {
    return supportedLanguages.has(selected!) ? (selected ?? defaultLang) : defaultLang;
  }
  return defaultLang;
};
